import { useEffect } from 'react';
import { BizIcon } from '../../Core/Components/Mini/BizIcon';
import { useCreateDirectMessage } from '../../Core/Hooks/admin/useChat';
import { ObjectType } from '../../Core/Types/base';
import { ChatUser } from '../../Core/Types/chat';
import './ChatUsers.scss';
import BizUserImage from '../../Core/Components/Mini/BizUserImage';

type ChatUsersProps = {
	users: ChatUser[];
	currentUserId: number;
	//onUserClick?: (user: ChatUser) => void;
	showModeration?: boolean;
	objectType?: ObjectType;
	objectId?: number;
	onCreateDirectMessageDone: (newRoomId: number) => void;
	hideCurrentUser?: boolean;
};

const ChatUsers = ({
	users,
	currentUserId,
	objectType,
	objectId,
	onCreateDirectMessageDone,
	hideCurrentUser,
}: ChatUsersProps) => {
	const { createDirectMessage, statusState, result, directMessageToUserId } = useCreateDirectMessage(objectType, objectId);

	useEffect(() => {
		if (statusState === 'SUCCESS' && result) {
			onCreateDirectMessageDone(result.Id);
		}
	}, [result, statusState]);

	const handleUserClick = (user: ChatUser) => {
		if (user.UserId === currentUserId) return;

		createDirectMessage(user.UserId);
	};

	return (
		<div className='biz-chat-users'>
			<div className='users-list'>
				{users
					.filter((usr) => !hideCurrentUser || usr.UserId !== currentUserId)
					.map((user) => (
						<div
							key={user.UserId}
							className={`user-item ${user.UserId === currentUserId ? 'current-user' : ''} ${user.UserId !== currentUserId ? 'clickable' : ''}`}
							onClick={() => handleUserClick(user)}
						>
							<BizUserImage imageUrl={user.UserPhoto} size={32} fullname={user.UserDisplayName} />
							<div className='user-info'>
								<span className='user-name'>{user.UserName}</span>
							</div>
							{directMessageToUserId === user.UserId && statusState === 'LOADING' && <BizIcon icon='LOADING' />}
						</div>
					))}
				{users.length === 0 && <div className='no-users'>No users online</div>}
			</div>
		</div>
	);
};

export default ChatUsers;
